import { IGoodsDetail } from '@/api/types/public';
import { formatNumber } from '@/utils/tools';
import { useLocale } from 'next-intl';
import { useTranslations } from '@/i18n/use-translations';
import { useMemo } from 'react';
import { FrameSize, useFrameSize } from './useFrameSize';

export const useFrameSizeAfterFormat = (detail: IGoodsDetail['product'], inches?: boolean) => {
  const calculatedFrameSize = useFrameSize(detail, inches);
  const locales = useLocale();
  const t = useTranslations('goodsDetail');
  const frameSize = useMemo(() => {
    const lang = (() => {
      if (locales === 'de') {
        return 'de-DE';
      }
      if (locales === 'fr') {
        return 'fr-FR';
      }
      return 'en-US';
    })();
    const keyMap: Record<string, keyof FrameSize> = {
      totalLengthValue: 'frame_total_length',
      glassWidthValue: 'glass_width',
      lensHeightValue: 'glass_height',
      legLengthValue: 'frame_leg_length',
      bridgeValue: 'frame_bridge',
    };
    const result = {
      totalLengthValue: '-',
      glassWidthValue: '-',
      lensHeightValue: '-',
      legLengthValue: '-',
      bridgeValue: '-',
    };
    for (const key in result) {
      const detailKey = keyMap[key];
      if (calculatedFrameSize[detailKey]) {
        result[key] =
          `${formatNumber(calculatedFrameSize[detailKey], 2, lang, inches)} ${inches ? t('params.values.inch') : t('params.values.millimeter')}`;
      }
    }
    return result;
  }, [calculatedFrameSize, locales, inches]);
  return frameSize;
};
